<ng-container *transloco="let t; read: 'documents.sentiment'">
  <h2 class="meta-title">{{ t('edit') }}</h2>

  <app-sentiment-control
    [projectId]="projectId()"
    [sentimentScale]="sentimentScale()"
    [sentimentScore]="sentimentScore()"
    [sentimentValue]="sentimentValue()"
    sentimentRangeType="document"
    (manualSentimentChange)="manualSentiment = $event"
  ></app-sentiment-control>

  @if (hasChanges()) {
    <label for="sentiment-editor-comment-input" class="kxi-text-large">{{ t('comments') }}</label>
    <div class="sentiment-editor__comments">
      <xi-text-area
        id="sentiment-editor-comment-input"
        ngDefaultControl
        [(ngModel)]="comment"
        [placeholder]="t('leave-comment')"
        name="comment"
        [height]="100"
      ></xi-text-area>
    </div>
  }

  <div class="text-right">
    <button mat-button (click)="cancelSentiment()">{{ t('cancel') }}</button>

    <button
      mat-button
      color="primary"
      [disabled]="isLoading() || !hasChanges()"
      (click)="saveSentiment()"
    >
      {{ t('save') }}
    </button>
  </div>
</ng-container>
